<ng-container *ngIf="selectMode">
    <h2>Background Information</h2>
    <div style="margin-top: 20px;">
        <span style="display:inline-block; width: 75%;">
            <label>How will this module help me design a well construction plan that meets all applicable regulatory requirements?</label>
        </span>
        <span style="display:inline-block; width: 20%;">
            <button class="button" style="width: 100%;" (click)="viewContent('overview')">Overview</button>
        </span>
    </div>
    <div style="margin-top: 20px;">
        <span style="display:inline-block; width: 75%;">
            <label>What options will I have to successfully complete a well construction plan?</label>
        </span>
        <span style="display:inline-block; width: 20%;">
            <button class="button" style="width: 100%;" (click)="viewContent('options')">Options</button>
        </span>
    </div>
    <div style="margin-top: 20px;">
        <span style="display:inline-block; width: 75%;">
            <label>What well construction details will be included in the approval permit?</label>
        </span>
        <span style="display:inline-block; width: 20%;">
            <button class="button" style="width: 100%;" (click)="viewContent('issuedPermit')">Issued Permits</button>
        </span>
    </div>
    <div style="margin-top: 20px;">
        <span style="display:inline-block; width: 75%;">
            <label>What well construction objectives required by Ohio law (ORC Chapter 1509), should be considered as I develop a proposed plan?</label>
        </span>
        <span style="display:inline-block; width: 20%;">
            <button class="button" style="width: 100%;" (click)="viewContent('objectives')">Objectives</button>
        </span>
    </div>
    <div style="margin-top: 20px;">
        <span style="display:inline-block; width: 75%;">
            <label>How can I be sure that I have complied with all applicable requirements of Ohio rules (<a target="_blank" href="/law-library/0bnpCg0bpf2uqLx" rel="noopener noreferrer">ORC 1509:9</a>) in my well construction plan?</label>
        </span>
        <span style="display:inline-block; width: 20%;">
            <button class="button" style="width: 100%;" (click)="viewContent('compliance')">Compliance</button>
        </span>
    </div>
    <div style="margin-top: 20px;">
        <span style="display:inline-block; width: 75%;">
            <label>What information is required by law/rule to be submitted in order to develop an approvable casing plan?</label>
        </span>
        <span style="display:inline-block; width: 20%;">
            <button class="button" style="width: 100%;" (click)="viewContent('requirements')">Requirements</button>
        </span>
    </div>
    <div style="margin-top: 20px;">
        <span style="display:inline-block; width: 75%;">
            <label>What authority does the law/rule grant the Chief to require site-specific well construction practices as enforceable permit conditions?</label>
        </span>
        <span style="display:inline-block; width: 20%;">
            <button class="button" style="width: 100%;" (click)="viewContent('backgroundConditions')">Conditions</button>
        </span>
    </div>
    <div style="margin-top: 20px;">
        <span style="display:inline-block; width: 75%;">
            <label>What are "alerts"? How will I receive them? How might alerts influence my construction plan?</label>
        </span>
        <span style="display:inline-block; width: 20%;">
            <button class="button" style="width: 100%;" (click)="viewContent('alerts')">Alerts</button>
        </span>
    </div>
    <div style="margin-top: 20px;">
        <span style="display:inline-block; width: 75%;">
            <label>UIC for casing requirements for Saltwater Injection, Enhanced Recovery, and Solution Mining.</label>
        </span>
        <span style="display:inline-block; width: 20%;">
            <button class="button" style="width: 100%;" (click)="viewContent('uic')">UIC</button>
        </span>
    </div>
</ng-container>
<ng-container *ngIf="!selectMode">
	<div class="grid-x">
		<div class="cell large-10">
			<ng-container [ngSwitch]="viewingContent">
				<ng-container *ngSwitchCase="'overview'">
					<h2>Background: Overview</h2>
					<section>
						<p>Development of a site-specific casing and cementing plan is one of the most important aspects of your application for permit to drill. According to <a target="_blank" href="/law-library/05Qmsu06hpSJ2joc" rel="noopener noreferrer">ORC 1509:6(C)</a> the approved plan is enforceable. This module will:</p>
						<ul>
							<li>Provide a list of well construction performance objectives that are mandated by statute and are applicable to every well plan.</li>
							<li> Provide "Alerts" if your proposed location is within an area where conditions exist that will influence your well construction plan.</li>
							<li>Provide links to applicable statutes and rules.</li>
							<li>Provide links to geographic and geologic information that can help guide the development of a site-specific well construction plan.</li>
							<li>Provide links to records for offset oil and gas wells.</li>
							<li>Provide links to area water well records that have been located by the ODNR Division of Water Resources (DWR) and are available at the DWR website. (Note: these records are not comprehensive)</li>
							<li>Enable the user to explain how the proposed plan is informed by data that may not be presently available to the DOGRM application viewer.</li>
							<li>Enable the user to submit an alternative surface casing proposal with supporting information.</li>
							<li>Enable the user to build a plan, string by string, that is viewable in table form and as a schematic.</li>
						</ul>
					</section>

				</ng-container>
				<ng-container *ngSwitchCase="'options'">
					<h2>Background: Options</h2>
					<div>
						Ths applicant will have the option of developing a well construction casing plan by:
						<ul>
							<li>
								Manually entering data on a field-by-field basis through a "Guided" or "Experienced User" version.
							</li>
						</ul>
					</div>
				</ng-container>
				<ng-container *ngSwitchCase="'issuedPermit'">
					<h2>Background: Issued Permits</h2>
					<div>
						The approved plan will automatically become part of enforceable well construction permit conditions attached to each permit that include:
						<ul>
							<li>
								The approved plan in table view,
							</li>
							<li>
								A schematic that depicts your approved plan,
							</li>
							<li>
								Site-specific alerts and associated permit conditions (e.g., "Reconditioned Casing"),
							</li>
							<li>
								Contingent (site or well-specific) requirement (e.g., cement basket requirement if a mine string is necessary,
								guide shoe test if drilling in an over-pressurized area, annular pressure monitoring requirement if stimulated
								by hydraulic fracturing),
							</li>
							<li>
								Standard requirements applicable to all drilling operations (e.g., cement quality, centralization) wellbore conditioning,
								etc.;
							</li>
							<li>
								Inspector notification requirements (<a target="_blank" href="/law-library/10Pjsl16uCWz0Vz8" rel="noopener noreferrer">OAC 1501:9-1-08(L)</a>).
							</li>
						</ul>
					</div>
				</ng-container>
				<ng-container *ngSwitchCase="'objectives'">
					<h2>Background: Objectives</h2>
					<div>
						Section <a target="_blank" href="/law-library/vobuQvEuHp27ZT" rel="noopener noreferrer">1509:17 ORC</a> establishes well construction objectives that are applicable to all wells.
						<br />
						According to <a target="_blank" href="/law-library/vobuQvEuHp27ZT" rel="noopener noreferrer">1509:17 ORC</a>, all wells must be constructed in a manner approved by the Chief as specified by the permit,
						and in a manner that meets the following mandated objectives:
						<ul>
							<li>
								Solicits unconsolidated sediments, such as glacial or outwash deposits;
							</li>
							<li>
								Isolates underground mine voids in accordance with <a target="_blank" href="/law-library/vobxYvI7Meg9F" rel="noopener noreferrer">ORC 1509:18</a>;
							</li>
							<li>
								Protects and isolates all Underground Sources of Drinking Water, as defined in <a target="_blank" href="/law-library/0bnpOI0c3D5l2cZI" rel="noopener noreferrer">OAC 1501:9-1-1(A)(52)</a>;
							</li>
							<li>
								Controls formation pressures to prevent blowouts;
							</li>
							<li>
								Isolates corrosive (primarily sour gas) zones;
							</li>
							<li>
								Isolates flow zones as defined in <a target="_blank" href="/law-library/05QirG06fc7a2BsB" rel="noopener noreferrer">OAC 1501:9-1-1(A)(37)</a> to prevent annular over-pressurization as defined
								in <a target="_blank" href="/law-library/05QirI06go2LtgN" rel="noopener noreferrer">ORC 1509:01(BB)</a>; and
							</li>
							<li>
								Isolates all hydrocarbon reservoirs that will be stimulated or tested
							</li>
						</ul>
					</div>
				</ng-container>
				<ng-container *ngSwitchCase="'compliance'">
					<h2>Background: Compliance</h2>
					<div>
						The first step in satisfying division requirements is submittal of a well construction plan as part of your permit application
						pursuant to <a target="_blank" href="/law-library/05Qi6505VA7t2N89" rel="noopener noreferrer">OAC 1501:9-1-02(A)(6)</a>. Division geologists will view your casing plan proposal to ensure that your well construction
						plan addresses all subsurface conditions that can be reasonably anticipated based upon the existing records reflecting the best
						available geologic information. The following discussion will provide insight into Ohio subsurface conditions as well as links
						to the maps, online information sources, and GIS coverages that will guide the geologist's review of your proposed well construction
						plan. In some cases, such as drilling operations on multi-well pads, you may have geologic information that is highly site-specific
						derived from wire-line logs and pre-drill water supply surveys. If your depth projections for specific casing strings differ from
						those derived from Division information sources, the user shall describe the basis for your well construction plan.
					</div>
					<div>
						The Division will ultimately evaluate your well construction compliance based upon how effectively your as-built well meets the
						objectives listed in <a target="_blank" href="/law-library/vobuQvEuHp27ZT" rel="noopener noreferrer">ORC 1509.17</a>. Your plan, and the plan approved by Division geologists, should be considered a best estimate
						that is based upon the best available geologic information prior to drilling. As real-world conditions may vary from pre-drill
						plans, the Division expects you to make appropriate adaptations and modifications of your approved plan, as necessary to fulfill
						the objectives listed in Section <a target="_blank" href="/law-library/vobuQvEuHp27ZT" rel="noopener noreferrer">1509.17 ORC</a>. This may include increasing or decreasing the length of specific casing strings,
						or adding casing strings, or adjusting cement volumes and additives, to address conditions that could not be reasonably
						anticipated prior to drilling
					</div>
					<div>
						Section <a target="_blank" href="/law-library/10Pjsl16uCWz0Vz8" rel="noopener noreferrer">1501.9-1-08(L) OAC</a> requires notification of the Division inspector prior to every casing cement job. Inspectors are
						authorized to approve necessary modifications to your proposed casing plan based upon information acquired during the drilling
						operation (e.g., shorten or lengthen the conductor casing based on actual thickness of glacial drifts as determined by drilling
						operations). However, inspectors will not approve significant revisions to the approved plan attached to the permit to drill (e.g.,
						elimination of an approved casing string).
					</div>
					<div>
						Section <a target="_blank" href="/law-library/0bnpE20byVZx2qSB" rel="noopener noreferrer">1501.9-1-08(J)(6) OAC</a> requires the owner or the owner's representative to be on location during each cement job
						to ensure compliance with cementing standards. The owner or owner's representative can discuss necessary modifications
						with the DOGRM inspector. Rigid compliance with the approved well construction plan is not a defense for failing to meet
						well construction objectives. Completing this plan is simply the first step in designing and constructing a well that
						satisfies all statutory well construction requirements.
					</div>
					<div>
						The Division does not dictate wellbore diameter or casing outer-diameters. However, Section <a target="_blank" href="/law-library/0bnpE30bA9ci18E4" rel="noopener noreferrer">1501.9-1-08(H) OAC</a> requires
						a minimum annular space of one inch between the wellbore and the outside diameter of the casing collar. Therefore, if drilling
						in areas where you might need to run an additional, unanaticipated casing string, such as an area that may have multiple
						abandoned, underground mines, you should plan wellbore diameters and casing diameters accordingly. As an alternative,
						you shold consider a geotechnical boring to confirm site-specific conditions prior to commencement of drilling.
					</div>
				</ng-container>
				<ng-container *ngSwitchCase="'requirements'">
					<h2>Background: Requirements</h2>
					<div>
						The following sections of the Ohio Revised Code (ORC) and Ohio Administrative Code (OAC) address well construction plans that
						must be submitted as part of a complete application for permit.
					</div>
					<div>
						<a target="_blank" href="/law-library/WI1fvc" rel="noopener noreferrer">ORC 1509 (A)</a> An application for a permit to drill a new well, drill an existing well deeper, reopen a well, convert a well to
						any use other than its original purpose, or plug back a well to a different source of supply, including associated production
						operations, shall be filed with the chief of the division of oil and gas resources management upon such form as the chief
						prescribes and shall contain each of the following that is applicable:
					</div>
					<div>
						<a target="_blank" href="/law-library/0bnq040cgJibzMB" rel="noopener noreferrer">ORC 1509(A)(6)(a)</a> The geological formation to be tested or used and the proposed total depth of the well;
					</div>
					<div>
						<a target="_blank" href="/law-library/0bnpU00c9kiS1ri9" rel="noopener noreferrer">ORC 1509(A)(7)</a> The type of drilling equipment to be used;
					</div>
					<div>
						<a target="_blank" href="/law-library/0bnq1R0cj2wh1rlo" rel="noopener noreferrer">OAC 1501:9-1-02(6)(A)</a> Application for permit: A casing plan and cementing plan showing how the owner propses to drill and
						construct the well consistent with the best available geologic information in the vicinity of the proposed wellbore and
						compliant with the rule <a target="_blank" href="/law-library/05Qm1v05V9Pp0nkO" rel="noopener noreferrer">OAC 1501:9-1-08</a>, including
						<ul>
							<li>
								The name and anticipated depth of all zones to be tested or produced;
							</li>
							<li>
								The estimated total depth of the wellbore;
							</li>
							<li>
								The anticipated diameter of each wellbore segment;
							</li>
							<li>
								The proposed casing type, outside diameter, and setting depth for each proposed casing string;
							</li>
							<li>
								Proposed cement volumes for each casing string; and
							</li>
							<li>
								Whether the owner plans to stimulate any permitted hydrocarbon zone by hydraulic fracturing.
							</li>
						</ul>
					</div>
					<div>
						<a target="_blank" href="/law-library/05Qm1v05V9Pp0nkO" rel="noopener noreferrer">OAC 1501:9-1-08</a> (Well Construction Standards)
						<br />
						The approved well construction plan will become part of the permit that must be visibly posted at the well site
						in accordance with <a target="_blank" href="/law-library/Flj2UGq9NL276x" rel="noopener noreferrer">ORC 1509.05</a>
					</div>
				</ng-container>
				<ng-container *ngSwitchCase="'backgroundConditions'">
					<h2>Background: Conditions</h2>
					<div>
						In addition to approving a casing plan, the Chief may issue a permit subject to terms and conditions that specify
						construction requirements, pursuant to the following sections in the Ohio Administrative Code (OAC):
						<table>
    <caption>New Casing Plan Background Information</caption>
							<tr>
								<th>OAC</th>
								<th>Section</th>
								<th>Topic</th>
							</tr>
							<tr>
								<td>1501:9-1-08</td>
								<td><a target="_blank" href="/law-library/0bnpFQ0bDy180lHP" rel="noopener noreferrer">(A)</a></td>
								<td>General Authority</td>
							</tr>
							<tr>
								<td>1501:9-1-08</td>
								<td><a target="_blank" href="/law-library/05Qibt067TtD2~1w" rel="noopener noreferrer">(B)</a></td>
								<td>Necessary to protect public health or safety or the environment</td>
							</tr>
							<tr>
								<td>1501:9-1-08</td>
								<td><a target="_blank" href="/law-library/05Qibu068eBLajD" rel="noopener noreferrer">(C)(2)</a></td>
								<td>Fluid drilling systems</td>
							</tr>
							<tr>
								<td>1501:9-1-08</td>
								<td><a target="_blank" href="/law-library/05Qidj068M7M0joA" rel="noopener noreferrer">(J)(5)</a></td>
								<td>Specific cement mixtures</td>
							</tr>
							<tr>
								<td>1501:9-1-08</td>
								<td><a target="_blank" href="/law-library/05Qif5069F2t1DfM" rel="noopener noreferrer">(J)(7)</a></td>
								<td>Use of corrosion resistent cements</td>
							</tr>
							<tr>
								<td>1501:9-1-08</td>
								<td><a target="_blank" href="/law-library/05Qmjp06aijU2Rce" rel="noopener noreferrer">(M)(4)(f)</a></td>
								<td>Surface casing depth in areas unmappable USDW's</td>
							</tr>
							<tr>
								<td>1501:9-1-08</td>
								<td><a target="_blank" href="/law-library/05QigS06aGDl1myK" rel="noopener noreferrer">(M)(6)(b)(v)</a></td>
								<td>Intermediate casing required</td>
							</tr>
						</table>
					</div>
				</ng-container>
				<ng-container *ngSwitchCase="'alerts'">
					<h2>Background: Alerts</h2>
					<p>"Alerts" are location-specific messages that inform the applicant that they are proposing to drill in areas that necessitate supplemental permit conditions. The alert will explain the "sensitives" of the proposed site, assist the applicant to factor those "sensitivities" in their well construction plan, and show all well construction-related permit conditions that will be attached to the permit, on a string by string basis.</p>
					<div>
						<p>Based upon the coordinates for your proposed well location, this module will automatically alert you to geologic conditions and features that could influence your well construction plan. For example, if you're proposing to drill a well in:</p>
						<ul>
							<li>
								The area of of review of an injection well;
							</li>
							<li>
								An area known to have potentially dangerous corrosive concentrations of hydrogen sulfide;
							</li>
							<li>
								An area with a history of shallow (&lt;3000 feet), natural gas shows;
							</li>
							<li>
								An area with known or possible abandoned underground mine voids;
							</li>
							<li>
								An area near or within a municipal groundwater supply well head protection area; or
							</li>
							<li>
								Other mapped features.
							</li>
						</ul>
					</div>
					<p>The system will alert you to this condition. The presence or absence of an alert does not absolve the applicant from the due diligence necessary to properly plan for site-specific conditions. The alert(s) will also appear as part of the listed permit conditions attached to the approved permit.</p>


				</ng-container>
				<ng-container *ngSwitchCase="'uic'">
					<h2>Background: UIC</h2>
					<div>
						General Underground Injection Well Casing requirements:
					</div>
					<div>
						Saltwater Injection Well <a target="_blank" href="/law-library/0nhh0w0np1qw2mMR" rel="noopener noreferrer">1501:9-3-05(A)(1-3)</a> & <a target="_blank" href="/law-library/05Qm1v05V9Pp0nkO" rel="noopener noreferrer">1501:9-1-08</a>
						<div>
							Surface Casing shall be set at least 50' through deepest underground source of drinking water containing less than
							10,000 ppm and cemented to surface.
						</div>
						<div>
							Injection casing shall be set and cemented at least 300' above the top of the injection zone.
						</div>
						<div>
							Injection shall be through tubing and packer set no more than 100' above the top of the injection zone.
						</div>
					</div>
					<div>
						Enhanced Recovery Injection Well <a target="_blank" href="/law-library/0nhh0w0np1qw2mMR" rel="noopener noreferrer">1501:9-3-05(A)(1-3)</a> & <a target="_blank" href="/law-library/05Qm1v05V9Pp0nkO" rel="noopener noreferrer">1501:9-1-08</a>
						<div>
							Surface Casing shall be set at least 50' through deepest underground source of drinking water containing less than
							10,000 ppm and cemented to surface.
						</div>
						<div>
							Injection casing shall be set and cemented at least 300' above the top of the injection zone.
						</div>
						<div>
							Injection shall be through tubing and packer set no more than 100' above the top of the injection zone.
						</div>
					</div>
					<div>
						Solution Mining Injection Well <a target="_blank" href="/law-library/0nhh0x0npXJ02lod" rel="noopener noreferrer">1501:9-7-08(A)(1)</a> & <a target="_blank" href="/law-library/05Qm1v05V9Pp0nkO" rel="noopener noreferrer">1501:9-1-08</a>
						<div>
							Surface Casing shall be set at least 50' through deepest underground source of drinking water containing less than
							10,000 ppm and cemented to surface.
						</div>
						<div>
							Injection casing shall be set to the injection zone and cemented to surface.
						</div>
					</div>
				</ng-container>
				<ng-container *ngSwitchDefault>To do</ng-container>
			</ng-container>
		</div>
		<div class="cell large-2">
			<button class="button" (click)="backToIndex()">Back to Index</button>
		</div>
	</div>
</ng-container>